'use client';
import { LegalShell, LegalSection, useLang, type Lang } from '@/components/LegalShell';

const C: Record<Lang, { title: string; sub: string; updated: string; s: { h: string; p: string[] }[] }> = {
  uk: {
    title: 'Угода користувача', updated: '18.07.2026',
    sub: 'Правила користування сайтом gamessales.vip та його сервісами.',
    s: [
      { h: '1. Прийняття умов', p: ['Використовуючи сайт, ви погоджуєтесь із цією Угодою, Публічною офертою та Політикою конфіденційності.'] },
      { h: '2. Обліковий запис', p: ['Ви відповідаєте за збереження доступу до свого акаунта й за всі дії, здійснені під ним. Вказуйте достовірні дані при реєстрації та оформленні замовлень.'] },
      { h: '3. Правила використання', p: ['Заборонено використовувати сайт для протиправних дій, обходу регіональних обмежень платформ, перепродажу з порушенням правил Microsoft, а також будь-яких дій, що завдають шкоди сервісу чи іншим користувачам.'] },
      { h: '4. Цифрові товари', p: ['Придбані ключі/коди/доступи призначені для особистого використання. Продавець не гарантує роботу товару в разі порушення покупцем правил платформи Microsoft.'] },
      { h: '5. Зміни', p: ['Ми можемо оновлювати умови Угоди. Актуальна версія завжди доступна на цій сторінці.'] },
    ],
  },
  ru: {
    title: 'Пользовательское соглашение', updated: '18.07.2026',
    sub: 'Правила пользования сайтом gamessales.vip и его сервисами.',
    s: [
      { h: '1. Принятие условий', p: ['Используя сайт, вы соглашаетесь с настоящим Соглашением, Публичной офертой и Политикой конфиденциальности.'] },
      { h: '2. Учётная запись', p: ['Вы отвечаете за сохранность доступа к своему аккаунту и за все действия, совершённые под ним. Указывайте достоверные данные при регистрации и оформлении заказов.'] },
      { h: '3. Правила использования', p: ['Запрещено использовать сайт для противоправных действий, обхода региональных ограничений платформ, перепродажи с нарушением правил Microsoft, а также любых действий, наносящих ущерб сервису или другим пользователям.'] },
      { h: '4. Цифровые товары', p: ['Приобретённые ключи/коды/доступы предназначены для личного использования. Продавец не гарантирует работу товара при нарушении покупателем правил платформы Microsoft.'] },
      { h: '5. Изменения', p: ['Мы можем обновлять условия Соглашения. Актуальная версия всегда доступна на этой странице.'] },
    ],
  },
  en: {
    title: 'User Agreement', updated: '2026-07-18',
    sub: 'Rules for using the gamessales.vip website and its services.',
    s: [
      { h: '1. Acceptance', p: ['By using the site you agree to this Agreement, the Public Offer and the Privacy Policy.'] },
      { h: '2. Account', p: ['You are responsible for keeping your account secure and for all actions performed under it. Provide accurate data during registration and checkout.'] },
      { h: '3. Usage rules', p: ['It is prohibited to use the site for unlawful activity, circumventing platform region restrictions, reselling in violation of Microsoft rules, or any actions harming the service or other users.'] },
      { h: '4. Digital goods', p: ['Purchased keys/codes/access are intended for personal use. The Seller does not guarantee the goods will work if the buyer violates Microsoft platform rules.'] },
      { h: '5. Changes', p: ['We may update the Agreement. The current version is always available on this page.'] },
    ],
  },
};

export default function TermsPage() {
  const lang = useLang();
  const c = C[lang];
  return (
    <LegalShell title={c.title} subtitle={c.sub} updated={c.updated}>
      {c.s.map(sec => (
        <LegalSection key={sec.h} heading={sec.h}>
          {sec.p.map((t, i) => <p key={i} style={{ margin: i ? '10px 0 0' : 0 }}>{t}</p>)}
        </LegalSection>
      ))}
    </LegalShell>
  );
}
